import React from 'react'
import { Grid, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { Form, Dropdown } from 'formsy-semantic-ui-react';
import { toastr } from 'react-redux-toastr';
@source({
    mouseEnter: (props) => {
        dispatch.app.setHelpContext('Priority')
    }
})

class Priority extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            priorityList: [
                { key: "NA", text: "NA", value: "NA" },
                { key: "High", text: "High", value: "High" },
                { key: "Medium", text: "Medium", value: "Medium" },
                { key: "Low", text: "Low", value: "Low" },
            ]
        }
    }

    async updatePriority(data, item) {
        let priority = {
            _id: this.props.selectedDataById._id,
            priority: item.value
        }
        // await dispatch.initiatives.updateInitiative(priority);
        await dispatch.initiatives.updateInitiativeBySpecificFields(priority) // Change made for KLM-9056
        toastr.success('Message', `Priority for initiative ${this.props.selectedDataById.name} is set to ${item.value}`);
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <div>
                <label>Select Priority </label>
                <Form
                    noValidate
                    className="addinitiativeForm formcyForm"
                    id='addinitiativeForm'
                >
                    <Dropdown
                        name="setPriority"
                        placeholder="Select"
                        search
                        selection
                        value={this.props.selectedDataById.priority}
                        required
                        validationErrors={{
                            isDefaultRequiredValue: 'Priority is required',
                        }}
                        errorLabel={errorLabel}
                        options={this.state.priorityList}
                        onChange={(data, value) => { this.updatePriority(data, value) }}
                    />
                </Form>
            </div>
        )
    }
}

export default Priority